// extracted by mini-css-extract-plugin
export default {"login_card":"Login_login_card__LIfVU","error_text":"Login_error_text__ZFrhO"};